// extracted by mini-css-extract-plugin
export var activeDot = "_2c-c";
export var buttonContainer = "_2c-9";
export var channelButton = "_2c-a";
export var clickable = "_2c-d";
export var content = "_2c-0";
export var contentFull = "_2c-2";
export var contentThird = "_2c-1";
export var contentWrapper = "_2c-7";
export var description = "_2c-5";
export var heightShort = "_2c-f";
export var image = "_2c-3";
export var imageContainer = "_2c-4";
export var selectButton = "_2c-e";
export var spinnerContainer = "_2c-b";
export var titleContent = "_2c-8";
export var titleWrapper = "_2c-6";